import { render, staticRenderFns } from "./ThemeSettingsDirectTopTef2.vue?vue&type=template&id=46872d48&scoped=true"
import script from "./ThemeSettingsDirectTopTef2.vue?vue&type=script&lang=js"
export * from "./ThemeSettingsDirectTopTef2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46872d48",
  null
  
)

export default component.exports